<template>
	<component
		v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'"
		class="flex flex-col"
	>
		<!-- to do: consistent, responsive, meaningful sizes in tailind config style="width: 48rem" -->
		<div class="flex-grow md:flex md:max-w-screen-md lg:max-w-screen-lg">
			<!-- left -->
			<div
				class="md:w-48 lg:w-60 bg-green-500 text-white flex flex-col p-4 flex-shrink-0 md:min-h-[32rem]"
			>
				<nav
					class="grid grid-cols-2 md:block md:flex-1 md:space-y-1"
					aria-label="Sidebar"
				>
					<div
						class="text-white group flex items-center px-2 py-2 font-medium rounded-md leading-5 cursor-pointer"
						:class="[index == step ? 'bg-green-600' : 'hover:bg-green-400']"
						v-for="(item, index) in steps"
						v-on:click.stop="tryGotoStep(index)"
						v-bind:key="index"
					>
						<ui-icon
							class="mr-2 flex-shrink-0 h-5 w-5"
							:name="item.icon"
							stroke-width="2"
						/>

						<span class="flex-1 truncate">{{ __(item.name) }}</span>
					</div>
				</nav>
			</div>

			<div class="flex-grow flex flex-col justify-between">
				<div class="absolute top-0 right-0 pt-4 pr-4">
					<button
						type="button"
						class="p-2 rounded-md text-white md:text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
						v-on:click="closeIframeModal()"
					>
						<span class="sr-only">{{ __("Close") }}</span>
						<ui-icon name="x" class="h-6 w-6" stroke-width="2" />
					</button>
				</div>

				<ui-alert-errors
					v-if="otherErrorMessages.length > 0"
					:messages="otherErrorMessages"
				/>

				<!-- active tab -->
				<component
					v-bind:is="activeStep.component"
					:key="'USER_EDIT_' + step"
					:user="user"
					:form="form"
					:uploads="uploads"
					:grid-cols="activeStep.gridCols"
					:iframe-modal="iframeModal"
					:step="step"
				/>

				<!-- layout semi -->
				<div
					class="flex justify-between pt-4 pb-6 px-6 bg-gray-50 items-center"
					v-if="step != 4"
				>
					<!-- do not show in file upload dialog -->

					<ui-button
						class="ml-auto"
						type="primary"
						:xdisabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Save"
					/>
				</div>
			</div>
		</div>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		user: {
			type: Object,
			required: true,
		},
		uploads: {
			type: Array,
			required: false,
			default: null,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form(
					Object.assign(this.user, {
						current_password: null,
						new_password: null,
						new_password_confirmation: null,
						file: null,
						label_id: null,
					})
				)
			),
			step: 0,
			steps: [
				{
					name: "Master data",
					component: "UserEditBaseData",
					icon: "home",
					cssClass: "",
				},
				{
					name: "Contact details",
					component: "UserEditContactDetails",
					icon: "user",
				},
				{
					name: "My Products",
					component: "UserEditMyProducts",
					icon: "database",
					gridCols: "6",
				},
				{
					name: "Bank account details",
					component: "UserEditBankAccountDetails",
					icon: "dollar-sign",
				},
				{
					name: "File uploads",
					component: "UserEditFileUploads",
					icon: "upload-cloud",
				},
				{
					name: "Loading and unloading details",
					component: "UserEditLoadingDetails",
					icon: "maximize-2",
				},
				{
					name: "Notifications",
					component: "UserEditNotifications",
					icon: "bell",
				},
				{ name: "Password", component: "UserEditPassword", icon: "lock" },
				{
					name: "Freunde werben Freunde",
					component: "UserUserReferral",
					icon: "bell",
				},
			],
		};
	},
	computed: {
		activeStep() {
			return this.steps[this.step];
		},
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
	},
	created() {
		// convenience feature: add location#step2 to go directly to step 2!
		let m = window.location.hash.match("#step([0-9])");
		if (m) {
			this.step = 1 * m[1];
			this.tryGotoStep(this.step);
		}
		if (window.location.hash.match("subscriptions")) {
			this.tryGotoStep(6);
		}
	},
};
</script>
